import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import "./SideBar.css";
import { appNavs } from "../../config";
import SideBarNav from "./SidebarNav";
import SidebarNavToggle from "./SidebarNavToggle";
import { useAuth0 } from "@auth0/auth0-react";
import { MdLogout, MdSettings } from "react-icons/md";
import { Icon } from "@aws-amplify/ui-react";
import { useMyContext } from "../../context/DataContext";
import { logError } from "../../utils/errorHandling";
import { hasModule } from "../../utils/moduleHelpers";
import { MODULES } from "../../config/modules";
const SideBar = () => {
  const [expand, setExpand] = useState(false);
  const { logout } = useAuth0();
  const { state, updateState } = useMyContext();
  const sidebarCollapsed = state.sidebarCollapsed;
  const setSidebarCollapsed = (value: boolean) => updateState('sidebarCollapsed', value);
  const queryString = window.location.search;
  let location = useLocation();

  // Handle sidebar collapse state changes from SidebarNav
  const handleCollapseChange = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  useEffect(() => {
    setExpand(false);
  }, [location]);

  // Update the context when sidebar collapse state changes
  useEffect(() => {
    updateState('sidebarCollapsed', sidebarCollapsed);
  }, [sidebarCollapsed, updateState]);

  const handleLogout = () => {
    void logout({ logoutParams: { returnTo: window.location.origin } }).catch((error) => {
      logError("Logout failed", error);
    });
  };

  return (
    <>
      <div className="btn-sidebar-nav">
        <SidebarNavToggle 
          expand={expand} 
          onChange={() => {
            const newExpand = !expand;
            setExpand(newExpand);
            // When mobile menu is expanded, make sure sidebar is expanded too
            if (newExpand) {
              setSidebarCollapsed(false);
            }
          }} 
        />
      </div>
      <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''} ${expand ? "visible" : ""}`}>
        <SideBarNav 
          navs={appNavs} 
          onCollapseChange={handleCollapseChange}
          initialCollapsed={sidebarCollapsed}
        />
        <div className="sidebar-nav setting-menu">
          <ul>
            {hasModule(MODULES.SETTINGS) && (
              <li>
                <NavLink to={`/settings${queryString ? queryString : ""}`}>
                  <Icon><MdSettings /></Icon>
                  Settings
                </NavLink>
              </li>
            )}

            <li>
              {/*<button onClick={() => logout({logoutParams: {returnTo: window.location.origin}})}>*/}
              {/*  <Icon><MdLogout /></Icon>*/}
              {/*  Log Out*/}
              {/*</button>*/}
              <NavLink to={`/${queryString ? queryString : ""}`} onClick={handleLogout}>
                <Icon><MdLogout /></Icon>
                Logout
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SideBar;
